import { UAParser } from 'ua-parser-js';
import { Component } from '@angular/core';
import { WizardPageComponent } from '../../../../core/wizard/wizard-page-component';
import type { WelcomeWizard } from '../welcome-wizard';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { HitTrackingService } from '../../../../core/hit-tracking/hit-tracking.service';
import { USER_TRACKING_ACTION_DESCRIPTIONS, USER_TRACKING_ACTIONS, USER_TRACKING_SOURCES } from 'src/app/core/constants/user-tracking.constants';

@Component({
  standalone: false,
  selector: 'mtn-welcome-wizard-end-page',
  templateUrl: './welcome-wizard-end-page.component.html',
  styleUrls: ['./welcome-wizard-end-page.component.scss']
})
export class WelcomeWizardEndPageComponent extends WizardPageComponent<WelcomeWizard> {

  key = 'end';

  constructor(
    private hitTrackingService: HitTrackingService,
  ) {
    super();
    this.title = 'Welcome! Let\'s get started.';
    this.stepperText = 'Finish';
    this.closeButtonText = 'Close';
    this.headerText = 'All Done!';
    this.subheaderText = 'You can always change any of these settings in My Profile & Settings.';
  }

  onClose(): Observable<null> {
    const meta = this.buildTrackingMeta();
    const OSmetadata = this.hitTrackingService.getFirstTimeSetupMetadata();

    // 🔹 Track Close
    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.FINISH,
      { ...meta, ...OSmetadata },
      USER_TRACKING_ACTIONS.FINISH_SETUP,
      USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.FINISH_SETUP],
      false
    ).subscribe();

    return super.onClose();
  }

  onDonotShowAgainClick(): any {
    const parser = new UAParser(navigator.userAgent).getResult();
    let deviceType = parser.device.type;
    if (!deviceType) {
      deviceType = 'desktop';
    }
    const meta = this.buildTrackingMeta();
    const OSmetadata = this.hitTrackingService.getFirstTimeSetupMetadata();

    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.FINISH,
      { ...meta, ...OSmetadata },
      USER_TRACKING_ACTIONS.OPT_OUT_FINISH,
      USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.OPT_OUT_FINISH],
      false
    ).subscribe();
  }

  onDonotShowAgainUnchecked(): any {
    const parser = new UAParser(navigator.userAgent).getResult();
    let deviceType = parser.device.type;
    if (!deviceType) {
      deviceType = 'desktop';
    }
    const meta = this.buildTrackingMeta();
    const OSmetadata = this.hitTrackingService.getFirstTimeSetupMetadata();

    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.FINISH,
      { ...meta, ...OSmetadata },
      USER_TRACKING_ACTIONS.OPT_IN_FINISH,
      USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.OPT_IN_FINISH], false
    ).subscribe();
  }

  private buildTrackingMeta(): any {
    return {
      time: new Date().toISOString(),
    };
  }
}
